import { render, staticRenderFns } from "./bimLeftMenu.vue?vue&type=template&id=3c6fe7e3&scoped=true&lang=html&"
import script from "./bimLeftMenu.vue?vue&type=script&lang=js&"
export * from "./bimLeftMenu.vue?vue&type=script&lang=js&"
import style0 from "./bimLeftMenu.vue?vue&type=style&index=0&id=3c6fe7e3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6fe7e3",
  null
  
)

export default component.exports